import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Slide, Typography } from "@mui/material";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { blue, red } from "@mui/material/colors";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { forwardRef } from "react";

const next_line = (str) => {
    if (str === null || str === "") return true;
    return null;
}

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ClientDetails({ client, handleClose, open }) {    
    const handleSelfClose = () => {
        handleClose(null);
    }

    const handleEditClose = () => {
        handleClose("edit");
    }

    if (client === null) return (<></>);
    return (
        <Dialog
            open={open}
            onClose={handleSelfClose}
            TransitionComponent={Transition}
            keepMounted
        >
            <DialogTitle variant="h5" color="info">{client.name}</DialogTitle>
            <DialogContent>
                <Grid container spacing={0.5}>
                    <Grid size={{ xs: 6, sm: 6 }}>
                        <Typography variant="body2">{client.client_id}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6, sm: 6 }} textAlign={"right"}>
                        <Typography variant="body2">{client.created}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <div className="align_text"><PhoneIcon fontSize="small" /> {client.phone}</div>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <div className="align_text"><EmailIcon fontSize="small" /> {client.email}</div>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption"> Accounts</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Typography variant="body2">Balance: {client.balance}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Opening Date: {client.opening_date}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Opening Balance: {client.opening_balance}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Scheme</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Fuel Charge: {client.fuel_charge ?? "NA"}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Pickup Charge: {client.pickup_charge ?? "NA"}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Pickup Scheme: {client.pickup_scheme ?? "NA"}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">Quotation: {client.quotation ?? "NA"}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Compliance</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="body2">GST: {client.gst_num ?? "NA"}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }} color={client.status === "Active" ? "" : red[500]}>
                        <Typography variant="body2"><div className="align_text">Status: {client.status} {client.status === "Active" ? "" : <ErrorOutlineOutlinedIcon fontSize="small" />}</div></Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Address</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="caption">Billing</Typography><Divider />
                        <Typography variant="body2">{client.billing_add_1}{next_line(client.billing_add_2) ?? <br />}{client.billing_add_2}{next_line(client.billing_add_3) ?? <br />}{client.billing_add_3}{next_line(client.billing_add_state) ?? <br />}{client.billing_add_state} {next_line(client.billing_add_zip) ?? "-"} {client.billing_add_zip}</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Typography variant="caption">Shipping</Typography><Divider />
                        <Typography variant="body2">{client.shipping_add_1}{next_line(client.shipping_add_2) ?? <br />}{client.shipping_add_2}{next_line(client.shipping_add_3) ?? <br />}{client.shipping_add_3}{next_line(client.shipping_add_state) ?? <br />}{client.shipping_add_state} {next_line(client.shipping_add_zip) ?? "-"} {client.shipping_add_zip}</Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button variant="contained" color="warning" disabled>Terminate</Button>
                <Button variant="outlined" color="info" onClick={handleEditClose}>Edit</Button>
                <Button variant="outlined" onClick={handleSelfClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

export default ClientDetails;